<template>
    <div>
      <div class="row">
        <div class="col-12">
          <h4>Change password for: {{generateName()}}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-8">
          <form>
            <div class="form-group">
              <label for="txtCurrentPassword">Current Password</label>
              <input type="password" class="form-control" id="txtCurrentPassword" v-model="current_password">
            </div>
            <div class="form-group">
              <label for="txtNewPassword">New Password</label>
              <input type="password" class="form-control" id="txtNewPassword" v-model="new_password">
            </div>
            <div class="form-group">
              <label for="txtConfirmNewPassword">Confirm Password</label>
              <input type="password" class="form-control" id="txtConfirmNewPassword" v-model="new_password_confirm">
            </div>
            <button type="button" class="btn btn-hub-primary" @click="submit()" >Submit</button>
            <router-link :to="{ name: 'AdminUsersIndex' }" class="btn btn-secondary">Cancel</router-link>
          </form>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'user-change-password',
  data: function () {
    return {
      current_password: '',
      new_password: '',
      new_password_confirm: ''
    }
  },
  props: [
    'user_id'
  ],
  computed: {
    ...mapGetters({
      user: 'singleUser'
    })
  },
  created () {
    this.$store.dispatch('getUser', this.user_id)
  },
  methods: {
    submit () {
      if (this.new_password !== this.new_password_confirm) {
        alert("Passwords do not match")
      }
      else if (this.current_password === this.new_password) {
        alert("New password must be different from current password")
      }
      else {
        this.$store.dispatch('changeUserPassword', { 
          user_id: this.user_id,
          current_password: this.current_password,
          new_password: this.new_password
        })
      }
    },
    generateName () {
      if (this.user.first && this.user.first !== '' && this.user.last && this.user.last !== '') {
        return this.user.last + ', ' + this.user.first
      }
      else {
        return this.user.username
      }
    }
  }
}
</script>

<style scoped>

</style>
